const MAX_HEADLINE_LENGTH = 100;
const MAX_SUBTITLE_LENGTH = 250;
const MAX_BENEFIT_LENGTH = 150;
const MAX_BENEFITS_COUNT = 10;

export interface ISalesArguments {
  headline: string;
  subtitle: string;
  benefits: string[];
  heroImage: string;
}

function sanitizeText(text: string, maxLength: number): string {
  return text.trim().slice(0, maxLength);
}

function parseBenefits(benefitsParam: string | null): string[] {
  if (!benefitsParam) {
    return [];
  }

  return benefitsParam
    .split("|")
    .map((benefit) => sanitizeText(benefit, MAX_BENEFIT_LENGTH))
    .filter((benefit) => benefit.length > 0)
    .slice(0, MAX_BENEFITS_COUNT);
}

function parseHeroImage(value: string | null): string {
  if (!value) return "";
  try {
    const url = new URL(decodeURIComponent(value));
    return url.protocol === "https:" ? url.href : "";
  } catch {
    return "";
  }
}

export default function parseSalesArguments(searchParams: URLSearchParams): ISalesArguments {
  const headline = searchParams.get("headline");
  const subtitle = searchParams.get("subtitle");
  const benefitsParam = searchParams.get("benefits");
  const heroImageParam = searchParams.get("hero_image");

  return {
    headline: headline ? sanitizeText(headline, MAX_HEADLINE_LENGTH) : "",
    subtitle: subtitle ? sanitizeText(subtitle, MAX_SUBTITLE_LENGTH) : "",
    benefits: parseBenefits(benefitsParam),
    heroImage: parseHeroImage(heroImageParam),
  };
}
